/**
 * @generated SignedSource<<dfe1be059cb34d3d09b9fdb74e5a709e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutinePositivePercentageSubscription$variables = {
  routineIds: ReadonlyArray<string>;
};
export type WidgetRoutinePositivePercentageSubscription$data = {
  readonly routineTaskExecutionChanged: {
    readonly id: string;
    readonly routineOccasion: {
      readonly id: string;
      readonly routine: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutinePositivePercentageRoutineItem_routine">;
      };
    };
  } | null;
};
export type WidgetRoutinePositivePercentageSubscription = {
  response: WidgetRoutinePositivePercentageSubscription$data;
  variables: WidgetRoutinePositivePercentageSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "routineIds",
    "variableName": "routineIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetRoutinePositivePercentageSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "routineTaskExecutionChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineOccasion",
            "kind": "LinkedField",
            "name": "routineOccasion",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routine",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WidgetRoutinePositivePercentageRoutineItem_routine"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetRoutinePositivePercentageSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "routineTaskExecutionChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineOccasion",
            "kind": "LinkedField",
            "name": "routineOccasion",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routine",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "ownerTeam",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineOccasion",
                    "kind": "LinkedField",
                    "name": "lastCompletedOccasion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "percentage",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1f1008cde536687645affa0e5178cd0d",
    "id": null,
    "metadata": {},
    "name": "WidgetRoutinePositivePercentageSubscription",
    "operationKind": "subscription",
    "text": "subscription WidgetRoutinePositivePercentageSubscription(\n  $routineIds: [ID!]!\n) {\n  routineTaskExecutionChanged(routineIds: $routineIds) {\n    __typename\n    id\n    routineOccasion {\n      id\n      routine {\n        id\n        ...WidgetRoutinePositivePercentageRoutineItem_routine\n      }\n    }\n  }\n}\n\nfragment WidgetRoutinePositivePercentageRoutineItem_routine on Routine {\n  id\n  title\n  ownerTeam {\n    name\n    id\n  }\n  lastCompletedOccasion {\n    endAt\n    percentage\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5db072ea1bde487c9d02d0034ec2de8c";

export default node;
